import React, { useEffect, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";


// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import axios from "axios";

const SidebarContent = props => {
  const ref = useRef();
  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  const [getUserType, setUserType] = React.useState("Admin");
  const [getSeenPage, setSeenPage] = React.useState([]);


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();

    let authUser = JSON.parse(localStorage.getItem("authUser"));
    if (authUser != null) {
      setUserType(authUser.Users_Type_ID)
    }

  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }


  return (
 <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Anasayfa")} </li>

            <li>
              <Link to="/" >
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Anasayfa")}</span>
              </Link>
            </li>
            <li>
              <Link to="/mainpagecategory" >
                <i className="bx bx-home-circle"></i>
                <span>{props.t("SSS")}</span>
              </Link>
            </li>


            <li>
              <Link to="/articleday" >
                <i className="bx bx-text"></i>
                <span>{props.t("Hakkımızda")}</span>
              </Link>
            </li>
           
     
            <li>
              <Link to="/users" >
                <i className="bx bx-user"></i>
                <span>{props.t("Kullanıcılar")}</span>
              </Link>
            </li>

            <li>
              <Link to="/advertesingform" >
                <i className="bx bx-star"></i>
                <span>{props.t("Hizmetlerimiz")}</span>
              </Link>
            </li>

            <li>
              <Link to="/company" >
                <i className="bx bx-diamond"></i>
                <span>{props.t("Blog")}</span>
              </Link>
            </li>

            <li>
              <Link to="/news" >
                <i className="bx bx-detail"></i>
                <span>{props.t("Hizmet Bölgeleri")}</span>
              </Link>
            </li>


            <li>
              <Link to="/companycategory" >
                <i className="bx bx-diamond"></i>
                <span>{props.t("Fiyatlar")}</span>
              </Link>
            </li>

  
            <li>
              <Link to="/newscategory" >
                <i className="bx bx-detail"></i>
                <span>{props.t("Reklam Alanı")}</span>
              </Link>
            </li>
            
           <li>
              <Link to="/jobadvertisement" >
                <i className="bx bx-file"></i>
                <span>{props.t("Mobil Bölgeler")}</span>
              </Link>
            </li>

{/**    <li>
              <Link to="/dinamikForm" >
                <i className="bx bx-map"></i>
                <span>{props.t("Mahalleler")}</span>
              </Link>
            </li>*/}

         

       <li>
              <Link to="/jobadvertisementcategory" >
                <i className="bx bx-stopwatch"></i>
                <span>{props.t("Saatler")}</span>
              </Link>
            </li> 

            <li>
              <Link to="/advertesingcategory" >
                <i className="bx bx-star"></i>
                <span>{props.t("Yapılan Ödemeler")}</span>
              </Link>
            </li>
         

          
{/**
            
            
          
          
         

            <li>
              <Link to="/companyadvertprice" >
                <i className="bx bx-diamond"></i>
                <span>{props.t("Rehber Reklam ücretleri")}</span>
              </Link>
            </li>
           
            <li>
              <Link to="/companysubcategory" >
                <i className="bx bx-diamond"></i>
                <span>{props.t(" Rehber Alt Kategorisi")}</span>
              </Link>
            </li>
       
         



            <li>
              <Link to="/songcategory" >
                <i className="bx bx-music"></i>
                <span>{props.t("Şarkı Kategorisi")}</span>
              </Link>
            </li>

          

            <li>
              <Link to="/song" >
                <i className="bx bx-music"></i>
                <span>{props.t("Şarkı")}</span>
              </Link>
            </li>
     
         
           
            <li>
              <Link to="/newscomment" >
                <i className="bx bx-comment"></i>
                <span>{props.t("Aktüel Yorumlar")}</span>
              </Link>
            </li>
            <li>
              <Link to="/jobadvertisementcategory" >
                <i className="bx bx-file"></i>
                <span>{props.t("İlan Kategorisi")}</span>
              </Link>
            </li>

            <li>
              <Link to="/jobadvertisementsubcategory" >
                <i className="bx bx-file"></i>
                <span>{props.t("İlan Alt Kategorisi")}</span>
              </Link>
            </li>
            <li>
              <Link to="/jobadvertisement" >
                <i className="bx bx-file"></i>
                <span>{props.t("İlanlar")}</span>
              </Link>
            </li>

     
            <li>
              <Link to="/slider" >
                <i className="bx bx-image"></i>
                <span>{props.t("İlanlar")}</span>
              </Link>
            </li>
            <li>
              <Link to="/forum" >
                <i className="bx bx-smile"></i>
                <span>{props.t("Bir Bilen")}</span>
              </Link>
            </li>
 */}
          </ul>
        </div>
      </SimpleBar>
      </React.Fragment>
   
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
